import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_URL = `${BACKEND_URL}/api`;

const TOKEN_KEY = "pp_access_token";
export const getToken = () => {
  try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
};
export const setToken = (t) => {
  try { if (t) localStorage.setItem(TOKEN_KEY, t); else localStorage.removeItem(TOKEN_KEY); } catch { /* ignore */ }
};

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

// Sertakan Bearer token sebagai fallback ketika cookie diblokir oleh
// iframe cross-site (mis. preview Emergent di app.emergent.sh).
api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Terjadi kesalahan. Silakan coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function fileUrl(fileId) {
  if (!fileId) return null;
  const t = getToken();
  return t ? `${API_URL}/files/${fileId}/download?auth=${encodeURIComponent(t)}` : `${API_URL}/files/${fileId}/download`;
}

export async function uploadFile(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/files/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return data;
}

export const SCHOOL_LOGO = "https://customer-assets.emergentagent.com/job_school-connect-281/artifacts/nbc9hj5v_LOGO%20SEKOLAH%20SLB%20resize-min.jpg";
export const SCHOOL_NAME = "SLB Pelita Nusa Pekanbaru";
export const SCHOOL_SHORT = "SLB Pelita Nusa";

export const ROLE_LABEL = {
  admin: "Administrator",
  kepala_sekolah: "Kepala Sekolah",
  guru: "Guru",
  orangtua: "Orang Tua",
  pustaka: "Petugas Pustaka",
  bendahara: "Bendahara",
};

export const ROLE_HOME = {
  admin: "/admin",
  kepala_sekolah: "/kepsek",
  guru: "/guru",
  orangtua: "/ortu",
  pustaka: "/pustaka",
  bendahara: "/bendahara",
};

export const BULAN = [
  { v: "01", label: "Januari" }, { v: "02", label: "Februari" }, { v: "03", label: "Maret" },
  { v: "04", label: "April" }, { v: "05", label: "Mei" }, { v: "06", label: "Juni" },
  { v: "07", label: "Juli" }, { v: "08", label: "Agustus" }, { v: "09", label: "September" },
  { v: "10", label: "Oktober" }, { v: "11", label: "November" }, { v: "12", label: "Desember" },
];

export function formatRupiah(n) {
  if (n == null) return "Rp 0";
  return "Rp " + Number(n).toLocaleString("id-ID");
}

export const SPP_PENERIMA = ["Hengki", "Hakim", "Adheestya"];
export const SPP_TAHUN = [2026, 2027, 2028, 2029, 2030];
export const SPP_KOMPONEN = [
  { v: "pendaftaran", label: "Pendaftaran" },
  { v: "pangkal", label: "Uang Pangkal" },
  { v: "spp", label: "SPP" },
  { v: "seragam", label: "Seragam" },
];
export const SPP_METODE = [
  { v: "tunai", label: "Tunai" },
  { v: "transfer", label: "Transfer" },
];

export function formatTanggal(iso) {
  if (!iso) return "—";
  // Accept "YYYY-MM-DD" or ISO datetime → return "DD-MM-YYYY"
  const s = String(iso);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return `${m[3]}-${m[2]}-${m[1]}`;
  const d = new Date(iso);
  if (isNaN(d)) return "—";
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${dd}-${mm}-${d.getFullYear()}`;
}

// Compute age in years from a "YYYY-MM-DD" (or ISO) date-of-birth string.
export function hitungUsia(dobStr) {
  if (!dobStr) return null;
  const m = String(dobStr).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return null;
  const y = parseInt(m[1], 10);
  const mo = parseInt(m[2], 10);
  const d = parseInt(m[3], 10);
  const t = new Date();
  let age = t.getFullYear() - y;
  const beforeBirthday = (t.getMonth() + 1) < mo || ((t.getMonth() + 1) === mo && t.getDate() < d);
  if (beforeBirthday) age -= 1;
  return age >= 0 ? age : null;
}

// LMS kategori pelatihan
export const LMS_KATEGORI = ["Pedagogi", "Karakter", "ABK", "Digital"];

// Age filter dropdown options for daftar siswa (label + backend query value).
export const USIA_FILTER_OPTIONS = [
  { v: "<5", label: "< 5 tahun" },
  { v: "5", label: "5 tahun" },
  ...Array.from({ length: 20 }, (_, i) => {
    const n = i + 6; // 6..25
    return { v: String(n), label: `${n} tahun` };
  }),
];

export default api;
